import { useEffect, useState } from 'react';
import { countPendingApprovals } from '../api/assignments';

/**
 * Badge con el total de pendientes de aprobación de la bandeja del jefe (spec §7):
 * propuestas de asignación + solicitudes de registro + cierres en borrador.
 */
export default function PendingBadge() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    countPendingApprovals()
      .then(({ proposals, applications, closures }) => {
        if (active) setCount(proposals + applications + closures);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (count === 0) return null;
  return (
    <span className="ml-2 inline-flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-semibold px-2 py-0.5">
      {count}
    </span>
  );
}
